var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(8 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .0026176c1.3303865 2.99783281 3.52247324 4.49674921 6.57626023 4.49674921s5.24553477-1.49978894 6.57524337-4.49936681",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.576475,
    cy: 9.753933,
    r: 5.299312
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.6205928 15.099578-.08823529 8.8087094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5764752 19.8326263h-10.00000005"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercury);
export default __webpack_public_path__ + "static/media/mercury.c3c78e49f55b6b8d0669aebad214f377.svg";
export { ForwardRef as ReactComponent };